import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonUtils} from "../../utils/common";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {environment} from "../../../environments/environment";
import {ReservationDhJsonDashboard} from "../../models/reservationDhJsonDashboard.model";

@Component({
  selector: 'app-reservation-json-element',
  templateUrl: './reservation-json-element.component.html',
  styleUrls: ['./reservation-json-element.component.scss'],
})
export class ReservationJsonElementComponent implements OnInit {
  @Input() reservationDhJson: ReservationDhJsonDashboard;
  @Output() addedReservationJsonEmitter: EventEmitter<ReservationDhJsonDashboard> = new EventEmitter<ReservationDhJsonDashboard>();
  @Output() cancelReservationJsonEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  dayReservationGroup: FormGroup;
  isBusy: any;

  constructor(public commonUtils : CommonUtils,
              private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.dayReservationGroup = this.formBuilder.group({
        startTime: [this.reservationDhJson.startTime, [Validators.required, Validators.pattern(environment.TIME_REGEXP_PATTERN)]],
        endTime: [this.reservationDhJson.endTime, [Validators.required, Validators.pattern(environment.TIME_REGEXP_PATTERN)]],
      });
  }


  onSave() {
    if (this.dayReservationGroup.valid) {
      let obj: ReservationDhJsonDashboard = this.commonUtils.formGroupValuesToObject<ReservationDhJsonDashboard>(new ReservationDhJsonDashboard(), this.dayReservationGroup);
      if (obj.startTime.split(':')[0]?.length === 1) {
        obj.startTime = 0 + obj.startTime;
      }
      if (obj.endTime.split(':')[0]?.length === 1) {
        obj.endTime = 0 + obj.endTime;
      }
      obj.dayIdx = this.reservationDhJson.dayIdx;
      obj.isFullDay = false;
      this.addedReservationJsonEmitter.emit(obj);
    } else {
      this.commonUtils.presentAlertToast('Błędny format czasu');
    }
  }

  onCancel() {
    this.cancelReservationJsonEmitter.emit(true);
  }

  markUnsavedChanges() {

  }
}
